import { Tooltip } from 'antd'
import { ViewItem } from './itemModel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNotEqual } from '@fortawesome/pro-solid-svg-icons'

type Props = { item: ViewItem }

const ItemDiffersIcon = ({ item }: Props) => {
  if (!item.differsFromMasterTask) {
    return <></>
  }

  return <Tooltip title="This item differs from the items in the master task." placement="topLeft">
    <FontAwesomeIcon icon={faNotEqual} style={{ marginRight: '5px' }} />
  </Tooltip>
}
export default ItemDiffersIcon
